import { useQuery } from "@tanstack/react-query";
import useAuth from "hooks/useAuth";
import { fetchTallerFormLookups } from "../Services/fetchTallerFormLookups";

export default function useTallerFormLookups({ countryId }) {
  const { accessToken } = useAuth();

  return useQuery({
    queryKey: ["serviceOperation", "tallerFormLookups", { countryId }],
    queryFn: () => fetchTallerFormLookups({ accessToken, countryId }),
    staleTime: Infinity,
    enabled: !!countryId && !!accessToken,
    retry: false,
  });
}